/** ДД.ММ — формат дат в карточке/графике личного рейтинга. */
export function fmtDayMonth(iso: string): string {
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}`;
}
